/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/common/app';
import Discussion from 'flarum/common/models/Discussion';
import ItemList from 'flarum/common/utils/ItemList';
import { slug } from '..';
const t = function () {
  return app.translator.trans(...arguments);
};
const prfx = `${slug}.forum.notifications`;
export default class FakeDiscussion extends Discussion {
  id = () => -1;
  title = () => t(`${prfx}.header`);
  badges = () => new ItemList(); // Else we get a random badge...
}
flarum.reg.add('glowingblue-gamilytics', 'common/models/FakeDiscussion', FakeDiscussion);